(function($)
{

  var $temp = $("<input>");
  var $url = $(location).attr('href');

  $('.b-v4-block-container-post-button').on('click', function() {
    $("body").append($temp);
    $temp.val($url).select();
    document.execCommand("copy");
    $temp.remove();
  })

})( jQuery );
